import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";
import { BankTransactionStagingResponseDto } from "../../shared/dtos/bankTransaction/BankTransactionStagingResponseDto";
import { PaginationDto } from "../../shared/dtos/common/PaginationDto";

export interface BankTransactionStagingState {
  loadingStagedTransactions: boolean;
  loadingStagedTransactionUpload: boolean;
  loadingStagedTransactionPost: boolean;
  loadingStagedTransactionDelete: boolean;
  errorLoadingStagedTransactions: string | null;
  errorUploadingStagedTransaction: string | null;
  errorPostingStagedTransaction: string | null;
  errorDeletingStagedTransaction: string | null;
  stagedTransactions: BankTransactionStagingResponseDto[];
  serverStatus: ServerStatusPayload | null;
  pagination: PaginationDto | null;
}

const initialState: BankTransactionStagingState = {
  loadingStagedTransactions: false,
  loadingStagedTransactionUpload: false,
  loadingStagedTransactionPost: false,
  loadingStagedTransactionDelete: false,
  errorLoadingStagedTransactions: null,
  errorUploadingStagedTransaction: null,
  errorPostingStagedTransaction: null,
  errorDeletingStagedTransaction: null,
  stagedTransactions: [],
  serverStatus: null,
  pagination: null,
};

export const bankTransactionStagingSlice = createSlice({
  name: "bankTransactionStaging",
  initialState,
  reducers: {
    setLoadingStagedTransactions(state) {
      state.loadingStagedTransactions = true;
      state.errorLoadingStagedTransactions = null;
    },
    setLoadingStagedTransactionUpload(state) {
      state.loadingStagedTransactionUpload = true;
      state.errorUploadingStagedTransaction = null;
    },
    setLoadingStagedTransactionPost(state) {
      state.loadingStagedTransactionPost = true;
      state.errorPostingStagedTransaction = null;
    },
    setLoadingStagedTransactionDelete(state) {
      state.loadingStagedTransactionDelete = true;
      state.errorDeletingStagedTransaction = null;
    },
    setErrorLoadingStagedTransactions(
      state,
      action: PayloadAction<string | null>,
    ) {
      state.loadingStagedTransactions = false;
      state.errorLoadingStagedTransactions = action.payload;
    },
    setErrorUploadingStagedTransaction(
      state,
      action: PayloadAction<string | null>,
    ) {
      state.loadingStagedTransactionUpload = false;
      state.errorUploadingStagedTransaction = action.payload;
    },
    setErrorPostingStagedTransaction(
      state,
      action: PayloadAction<string | null>,
    ) {
      state.loadingStagedTransactionPost = false;
      state.errorPostingStagedTransaction = action.payload;
    },
    setErrorDeletingStagedTransaction(
      state,
      action: PayloadAction<string | null>,
    ) {
      state.loadingStagedTransactionDelete = false;
      state.errorDeletingStagedTransaction = action.payload;
    },
    setStagedTransactions(
      state,
      action: PayloadAction<BankTransactionStagingResponseDto[]>,
    ) {
      state.loadingStagedTransactions = false;
      state.stagedTransactions = action.payload;
    },
    setPagination(state, action: PayloadAction<PaginationDto>) {
      state.pagination = action.payload;
    },
    uploadStagedTransactionSuccess(state) {
      state.loadingStagedTransactionUpload = false;
      state.errorUploadingStagedTransaction = null;
    },
    postStagedTransactionSuccess(state, action: PayloadAction<string>) {
      state.stagedTransactions = state.stagedTransactions.filter(
        (item) => item.id !== action.payload,
      );
      state.loadingStagedTransactionPost = false;
      state.errorPostingStagedTransaction = null;
    },
    deleteStagedTransactionSuccess(state, action: PayloadAction<string>) {
      state.stagedTransactions = state.stagedTransactions.filter(
        (item) => item.id !== action.payload,
      );
      state.loadingStagedTransactionDelete = false;
      state.errorDeletingStagedTransaction = null;
    },
    setServerResponseStatus(
      state,
      action: PayloadAction<ServerStatusPayload | null>,
    ) {
      state.serverStatus = action.payload;
    },
  },
});

export const bankTransactionStagingActions =
  bankTransactionStagingSlice.actions;
export default bankTransactionStagingSlice.reducer;
